const dayjs = require('dayjs');
export const arrayCommon = {
    isExisted: (arr, val) => {
        if (arr) {
            for (let i = 0; i < arr.length; i++) {
                if (arr[i] === val) {
                    return true;
                }
            }
        }

        return false;
    },
    removeElement: (arr, value) => {
        if (arr) {
            var index = arr.indexOf(value);
            if (index > -1) {
                arr.splice(index, 1);
            }
        }
    },
    range(start, end) {
        const length = end - start + 1;
        return Array.from({ length }, (_, i) => start + i);
    },
    equalArray(a, b) {
        if (a.length === b.length) {
            for (var i = 0; i < a.length; i++) {
                if (!b.includes(a[i])) {
                    return false;
                }
            }
            return true;
        } else {
            return false;
        }
    },
    findById(array, id) {
        if (!Array.isArray(array)) {
            return undefined;
        }
        var result;
        array.some(o => result = o.id === id ? o : this.findById(o.children || [], id));
        return result;
    },
    findByValue(array, value) {
        if (value == null || value == undefined) {
            return null;
        }
        if (!Array.isArray(array)) {
            return undefined;
        }
        var result;
        array.some(o => result = o.value === value ? o : this.findByValue(o.children || [], value));
        return result;
    }
};

export const shortFileName = (fileName, maxLength = 20) => {
    if (!fileName || fileName.length <= maxLength) return fileName;

    const lastDot = fileName.lastIndexOf(".");

    // Không có phần mở rộng
    if (lastDot === -1) {
        return fileName.substring(0, maxLength) + "...";
    }

    const ext = fileName.substring(lastDot); // .pdf, .docx,...
    const name = fileName.substring(0, lastDot);

    // Đảm bảo tổng độ dài không vượt quá maxLength
    const availableLength = maxLength - ext.length - 3; // 3 là "..."

    if (availableLength <= 0) {
        return fileName;
    }

    return `${name.substring(0, availableLength)}...${ext}`;
};

export const dateCommon = {
    formatDate: (date, format) => {
        if (typeof date === "string") {
            date = new Date(date);
        }

        if (!date) {
            return "";
        }

        if (!format) {
            format = "dd/MM/yyyy";
        }
        
        return format.replace(/dd/, ("0" + date.getDate()).slice(-2))
            .replace(/MM/, ("0" + (date.getMonth() + 1)).slice(-2))
            .replace(/yyyy/, date.getFullYear())
            .replace(/HH/, ("0" + date.getHours()).slice(-2))
            .replace(/mm/, ("0" + date.getMinutes()).slice(-2))
            .replace(/Q/, (Math.ceil(date.getMonth() / 3)).toString());
    },
    convertStringToDate: (date, format) => {
        if (date == null || date == undefined) {
            return null;
        }
        let d = date.split(/[.,/ -]/);
        let f = format.split(/[.,/ -]/);
        return new Date(d[f.indexOf("yyyy")], d[f.indexOf("MM")], d[f.indexOf("dd")]);
    },
    countDateBetween: (end, start) => {
        if (!end || !start) {
            return -1;
        }

        if (typeof end === "string") {
            end = new Date(end);
        }

        var differenceInTime = end.getTime() - start.getTime();
        var differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));
        return differenceInDays;
    },
    currentDateWithoutTime: () => {
        var now = new Date();
        return new Date(now.getFullYear(), now.getMonth(), now.getDate());
    },
    removeTime: (date) => {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate())
    },
    getDateValue: (date) => {
        if (date != null) {
            return new Date(date);
        } else {
            return null;
        }
    },
    getFirstDayOfMonth: () => {
        let date = new Date();
        return new Date(date.getFullYear(), date.getMonth(), 1);
    },
    getLastDayOfMonth: () => {
        let date = new Date();
        return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    },
    getThangNam: (dateStr) => {
        let date = new Date(dateStr);
        let month = (date.getMonth() + 1).toString().padStart(2, "0");
        let year = date.getFullYear();
        return month + "/" + year;
    },
    convertThangNamToDayjs: (ngayThang) => {
        // Sử dụng regex để kiểm tra định dạng "MM/YYYY"
        const regex = /^\d{2}\/\d{4}$/;
        if (!regex.test(ngayThang)) {
            return null;
        }

        // Nếu định dạng đúng, chuyển đổi sang kiểu dayjs
        const formattedDate = dayjs("01/" + ngayThang, 'DD/MM/YYYY', true);

        // Kiểm tra nếu ngày tháng hợp lệ
        if (formattedDate.isValid()) {
            //console.log('Ngày tháng hợp lệ:', formattedDate.format('YYYY-MM-DD'));
            return formattedDate;
        } else {
            return null;
        }
    },
    convertThangNamToDate: (ngayThang) => { // Sử dụng regex để kiểm tra định dạng "MM/YYYY"
        const regex = /^\d{2}\/\d{4}$/;
        if (!regex.test(ngayThang)) {
            //console.log('Định dạng ngày tháng không đúng.');
            return null;
        }

        // Chuyển đổi chuỗi ngày tháng sang kiểu Date
        const parts = ngayThang.split('/');
        const month = parseInt(parts[0], 10) - 1; // Giảm đi 1 vì tháng bắt đầu từ 0 trong đối tượng Date
        const year = parseInt(parts[1], 10);
        if (month < 0 || month > 11) {
            return null;
        }
        const convertedDate = new Date(year, month, 1);

        // Kiểm tra nếu ngày tháng hợp lệ
        if (!isNaN(convertedDate.getTime())) {
            //console.log('Ngày tháng hợp lệ:', convertedDate.toISOString());
            return convertedDate;
        } else {
            //console.log('Ngày tháng không hợp lệ.');
            return null;
        }
    },
};

const mimeTypes = {
    "pdf": "application/pdf",
    "PDF": "application/pdf",
    "jpg": "image/jpeg",
    "jpeg": "image/jpeg",
    "png": "image/png"
};

export const contentTypeCommon = {
    getByExt: (ext) => {
        if (!ext) {
            return;
        }

        return mimeTypes[ext.replace('.','')];
    }
};
// Hàm chuyển đổi số nguyên sang số La Mã
export const convertToRoman = (num) => {
    const romanNumerals = [
        { value: 1000, numeral: 'M' },
        { value: 900, numeral: 'CM' },
        { value: 500, numeral: 'D' },
        { value: 400, numeral: 'CD' },
        { value: 100, numeral: 'C' },
        { value: 90, numeral: 'XC' },
        { value: 50, numeral: 'L' },
        { value: 40, numeral: 'XL' },
        { value: 10, numeral: 'X' },
        { value: 9, numeral: 'IX' },
        { value: 5, numeral: 'V' },
        { value: 4, numeral: 'IV' },
        { value: 1, numeral: 'I' }
    ];

    let roman = '';

    romanNumerals.forEach(item => {
        while (num >= item.value) {
            roman += item.numeral;
            num -= item.value;
        }
    });

    return roman;
}
export const gioiTinhCommon = {
    toString: (gioiTinh) => {
        switch (gioiTinh) {
            case 0: return "Nam";
            case 1: return "Nữ";
            default: return "";
        }
    }
};

export const currencyFormat = {
    toCurrency: (num) => {
        if (num) {
            return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
        } else {
            return null;
        }
    },
    toVND: (num) => {
        if (num) {
            return num.toLocaleString('en-US', { style: 'currency', currency: 'VND' });
        } else {
            return null;
        }
    },
    formatMoney: (num) => {
        num = (num || 0) + "";
        if (num >= 0) {
            num = (num || 0) + "";
            return num.replace(/./g, function (c, i, a) {
                return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "." + c : c;
            });
        } else {
            num = (Math.abs(num) || 0) + "";
            var value = num.replace(/./g, function (c, i, a) {
                return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? "." + c : c;
            });
            return `-${value}`;
        }
    }
};

export const stringCommon = {
    ConvertToUnSign: (str) => {
        str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
        str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
        str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
        str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
        str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
        str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
        str = str.replace(/đ/g, "d");
        //str= str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'| |\"|\&|\#|\[|\]|~|$|_/g,"-");  
        /* tìm và thay thế các kí tự đặc biệt trong chuỗi sang kí tự - */
        //str= str.replace(/-+-/g,"-"); //thay thế 2- thành 1-  
        str = str.replace(/^\-+|\-+$/g, "");
        return str;
    },
    isEmpty: (str) => {
        if (typeof str == 'undefined' || !str || str.length === 0 || str === "" || !/[^\s]/.test(str) || /^\s*$/.test(str) || str.replace(/\s/g, "") === "")
            return true;
        else
            return false;
    }
}

export const arrayCommonElement = {
    findCommonElements: (arr1, arr2) => {
        return arr1.filter((num) => arr2.includes(num));
    },
    findDifferentElement: (arr1, arr2) => {
        return arr1.filter((num) => !arr2.includes(num));
    }
}

export const validateMessages = {
    required: "${label} bắt buộc nhập",
    string: {
        min: '${label} tối thiểu ${min} kí tự',
        max: '${label} tối đa ${max} kí tự',
    }
};

export const tabNameDSHopDong = {
    thongTinHopDong: "Thông tin hợp đồng",
    hopDongKhac: "Hợp đồng khác"
}

export const formatVND = (money) => {
    if (money == null) {
        return "0₫"
    }
    var config = { style: 'currency', currency: 'VND', maximumFractionDigits: 9 };
    return new Intl.NumberFormat('vi-VN', config).format(money);
}

export const formatVNDNoFractionDigit = (money) => {
    if (money == null) {
        return "0₫"
    }
    var config = { style: 'currency', currency: 'VND', maximumFractionDigits: 0 };
    return new Intl.NumberFormat('vi-VN', config).format(money);
}

export const formatVNDIn = (money) => {
    if (money == null) {
        return "-";
    }
    var config = { style: 'decimal', maximumFractionDigits: 9 };
    return new Intl.NumberFormat('vi-VN', config).format(money);
};

export const getFormData = (request) => {
    var formData = new FormData();
    Object.keys(request).forEach(key => {
        var a = request[key];
        request[key] != undefined ? formData.append(key, request[key]) : null
    });
    return formData;
}

export function roundToTwo(num) {
    return +(Math.round(num + "e+2") + "e-2");
}

export const roundToNearestThousand = (value) => {    
    return Math.round(value / 1000) * 1000;
};

export const roundToInt = (value) => {
    return Math.round(value);
};

export const layLoaiUngHo = (loai) => {
    var rs = ""
    switch (loai) {
        case 0: {
            rs = "Giảm trừ thu nhập"
        }
            break;
        case 1: {
            rs = "Thu nhập bổ sung"
        }
            break;
        default: {
            rs: "Không xác định"
        }
    }
    return rs;    
}
export const getXepLoaiString = (loai) => {
    var rs = ""
    switch (loai) {
        case 1.1: 
            rs = "A+";
            break;
        case 1: 
            rs = "A";
            break;
        case 0.9:
            rs = "B";
            break;
        case 0.8: 
            rs = "C";
            break;
        default:
            rs: "";
            break;
    }
    return rs;
}

export const layKieuTinhUngHo = (loai) => {
    var rs = ""
    switch (loai) {
        case 0: {
            rs = "Theo số tiền"
        }
            break;
        case 1: {
            rs = "Theo ngày công"
        }
            break;
        default: {
            rs: "Không xác định"
        }
    }
    return rs;
}

export const convertThangToNumber = (thangString) => {
    const match = thangString.match(/Tháng (\d{2})/);
    if (!match) {
        return 1;
    }

    return parseInt(match[1], 10);
}

export const parseThangTuMang = (mang) => {
    let result = [];

    let first = convertThangToNumber(mang[0]);
    let last = convertThangToNumber(mang[mang.length - 1]);
    for (let i = first; i <= last; i++) {
        result.push(i);
    }

    return result
}

// Quy đổi qua lại giữa tổng số tháng công tác và cặp (số năm, số tháng) dùng để nhập liệu
export const thoiGianCongTacCommon = {
    // Tách tổng số tháng thành { soNam, soThang }
    tachNamThang: (tongSoThang) => {
        const tong = Number(tongSoThang) || 0;
        return {
            soNam: Math.floor(tong / 12),
            soThang: tong % 12,
        };
    },
    // Gộp số năm và số tháng thành tổng số tháng
    gopNamThang: (soNam, soThang) => {
        return (Number(soNam) || 0) * 12 + (Number(soThang) || 0);
    },
    // Hiển thị dạng "x năm y tháng"
    hienThi: (tongSoThang) => {
        const tong = Number(tongSoThang) || 0;
        if (tong <= 0) {
            return '';
        }
        const { soNam, soThang } = thoiGianCongTacCommon.tachNamThang(tong);
        if (soNam === 0) {
            return `${soThang} tháng`;
        }
        return soThang === 0 ? `${soNam} năm` : `${soNam} năm ${soThang} tháng`;
    },
}

export const validateMinMax = (min, max, value, callback, label) => {
    const numericValue = Number(value);

    if (isNaN(numericValue)) {
        callback('Vui lòng nhập một số');
    } else if (min !== undefined && numericValue < min) {
        callback(`${label} tối thiểu là ${min}`);
    } else if (max !== undefined && numericValue > max) {
        callback(`${label} tối đa là ${max}`);
    } else {
        callback();
    }
};

export const tinhThueTNCNTheoThang = (thuNhap) => {
    let thueTNCN = 0;

    if (thuNhap <= 5000000) {
        thueTNCN = Math.round(0.05 * thuNhap);
    } else if (thuNhap <= 10000000) {
        thueTNCN = 0.1 * thuNhap - 250000;
    } else if (thuNhap <= 18000000) {
        thueTNCN = 0.15 * thuNhap - 750000;
    } else if (thuNhap <= 32000000) {
        thueTNCN = 0.2 * thuNhap - 1650000;
    } else if (thuNhap <= 52000000) {
        thueTNCN = 0.25 * thuNhap - 3250000;
    } else if (thuNhap <= 80000000) {
        thueTNCN = 0.3 * thuNhap - 5850000;
    } else {
        thueTNCN = 0.35 * thuNhap - 9850000;
    }

    return thueTNCN;
}

export const layTenNhomNhanSu = (idNhom) => {
    switch (idNhom) {
        case 1:
            return "Người lao động";
        case 2:
            return "NQL không chuyên trách";
        case 3:
            return "Ban điều hành";
        case 4:
            return "Thư ký";
        case 5:
            return "Tổ giúp việc HĐQL";
        case 6:
            return "Khác";
        case 7:
            return "Trưởng BKS";
        default:
            return "Không xác định"; 
    }
}